export const JSON_SCHEMA_KEYWORDS = [
  'additionalItems',
  'additionalProperties',
  'allOf',
  'anyOf',
  'const',
  'contains',
  'dependencies',
  'else',
  'enum',
  'errorMessage',
  'exclusiveMaximum',
  'exclusiveMinimum',
  'format',
  'formatExclusiveMaximum',
  'formatExclusiveMinimum',
  'formatMaximum',
  'formatMinimum',
  'if',
  'items',
  'maximum',
  'maxItems',
  'maxLength',
  'minimum',
  'minItems',
  'minLength',
  'multipleOf',
  'not',
  'oneOf',
  'pattern',
  'patternProperties',
  'patternRequired',
  'properties',
  'propertyNames',
  'then',
  'type',
  'uniqueItems',
];

export const JSON_SCHEMA_SAFE_HTML_KEYWORDS = ['maxLength', 'minLength'];
